import { FilterModuleStore, ModuleMap, ServerKey } from 'components/filter/types';
import { createWithEqualityFn as create } from 'zustand/traditional';

const useFilterModulesStore = create<FilterModuleStore>(set => ({
    modules: {} as ModuleMap,
    register: module =>
        set(state => {
            if (!state.modules[module.filterKey as ServerKey]) {
                return {
                    modules: {
                        ...state.modules,
                        [module.filterKey]: module,
                    },
                };
            }

            return state;
        }),
}));

export { useFilterModulesStore };
